module.exports = __webpack_public_path__ + "static/media/health.c4d35361.png";